import { styled, keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

interface IPropsStyledHeader {
  multiline?: boolean;
}

export const StyledHeader = styled.h4<IPropsStyledHeader>`
  font-weight: 600;
  margin: 0 8px 0 8px !important;
  color: rgb(36, 38, 55);
  display: flex;
  align-items: center;
  ${(props) =>
    props?.multiline &&
    "color: #64748b; font-size: 15px; font-weight: 400; padding-top: 16px; line-height: 1.6;"}
`;

export const StyledJobCard = styled.div`
  height: 100%;
  background: #f8fafc;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;

  .header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .close-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: none;
    background: #f1f5f9;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;

    svg {
      font-size: 20px;
      color: #64748b;
    }

    &:hover {
      background: #e2e8f0;
      svg {
        color: #334155;
      }
    }
  }
`;

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  font-family: "Inter", "Nunito", sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    font-size: 18px;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

export const DrawerContent = styled.div`
  height: calc(100vh - 69px);
  overflow-y: auto;
  padding: 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }
`;

export const DrawerSection = styled.div`
  padding: 20px;
  background: #ffffff;
  margin-bottom: 8px;

  .meta-row {
    display: flex;
    gap: 8px;
    margin-top: 8px;
  }

  &.comments-section {
    margin-bottom: 0;
    padding-bottom: 40px;
  }
`;

export const ButtonWrapper = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    outline: none;
    border: 1px solid #e2e8f0;
    padding: 8px 12px;
    border-radius: 8px;
    background: #ffffff;
    align-items: center;
    font-family: "Inter", "Nunito", sans-serif;
    transition: all 0.2s ease;

    &:hover {
      border-color: #cbd5e1;
      background: #f8fafc;
    }
  }
  .mark-complete {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 100px;
    gap: 6px;
  }
`;

export const DetailsWrapper = styled.div`
  padding: 8px;
`;

export const AssignedUserWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 56px;
  min-width: 200px;
  cursor: pointer;
  padding: 8px 12px;
  margin-top: 8px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid transparent;
  transition: all 0.2s ease;

  &:hover {
    border-color: #e2e8f0;
    background: #f1f5f9;
  }

  svg {
    color: #6366f1;
    font-size: 20px;
  }

  .assignee-height {
    height: 300px;
    overflow-y: scroll;
  }

  .assginee-detail {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  span {
    font-size: 12px;
    font-weight: 500;
    font-family: "Inter", "Nunito", sans-serif !important;
    color: #64748b;
  }

  .name {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    border-bottom: none;
    text-transform: capitalize;
  }

  .date-color {
    color: #6366f1;
  }
`;

export const AssigneeModalWrapper = styled.div`
  position: relative;
  .input-wrapper {
    display: flex;
    align-items: center;
    max-width: 300px;
    margin: 0 auto;
  }
  h3 {
    text-align: center;
  }
  .close-icon {
    color: #a0a0a0;
    position: absolute;
    right: 0;
    cursor: pointer;
  }
  .search-input {
    flex: 1;
    padding: 9px;
    border: 1px solid #ccc;
    border-radius: 5px 0 0 5px;
    width: 80%;
  }

  .search-button {
    padding: 10px 15px;
    background-color: #ec2026 !important;
    color: white;
    border: none;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    transition: background-color 0.3s;
    width: 20%;
  }

  .search-button:hover {
    background-color: #0056b3;
  }
  span {
    font-size: 14px;
    font-weight: 700;
    font-family: "Nunito", sans-serif !important;
  }
  .name {
    font-size: 16px;
    color: var(--primary-header);
    border-bottom: none;
  }
  .assginee-detail {
    display: flex;
    flex-direction: column;
  }
  .assignee-height {
    margin-top: 20px;
    height: 300px;
    overflow-y: scroll;
  }
  .assignee-list {
    cursor: pointer;
    &:hover {
      background: #eaeaea;
    }
  }
`;

export const CommentBoxWrapper = styled.form`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  margin-bottom: 16px;
  gap: 10px;

  input {
    flex: 1;
    height: 44px;
    padding: 0 14px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #f8fafc;
    color: #1e293b;
    font-family: "Inter", "Nunito", sans-serif;
    font-size: 14px;
    font-weight: 400;
    transition: all 0.2s ease;

    &::placeholder {
      color: #94a3b8;
    }

    &:focus {
      outline: none;
      border-color: #6366f1;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
    }
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: none;
    background: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease;

    svg {
      color: white;
      font-size: 20px;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
    }
  }
`;

export const JobDetailsWrapper = styled.div`
  padding: 0 20px;
  background: #ffffff;
  margin-bottom: 8px;

  h5 {
    text-align: center;
  }

  ol,
  ul {
    padding: 0 !important;
    margin-bottom: 0 !important;
    list-style: none;
  }

  ul li {
    display: flex;
    padding: 10px 0;
    border-bottom: 1px solid #f1f5f9;

    &:last-child {
      border-bottom: none;
    }
  }

  .titleValue {
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
    font-family: "Inter", "Nunito", sans-serif;
  }

  .title {
    width: 140px;
    min-width: 140px;
    color: #64748b;
    font-size: 13px;
    font-family: "Inter", "Nunito", sans-serif;
  }
`;

export const CommentWrapper = styled.div`
  padding: 0;
  margin-bottom: 20px;
  max-height: 400px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 2px;
  }

  .assginee-detail {
    display: flex;
    flex-direction: column;
    padding: 12px;
    background: #f8fafc;
    border-radius: 12px;
    margin-bottom: 10px;

    h4 {
      font-size: 13px;
      font-weight: 600;
      font-family: "Inter", "Nunito", sans-serif !important;
      display: flex;
      align-items: center;
      gap: 8px;
      color: #1e293b;
      margin: 0 0 6px 0;

      .comment-time {
        font-size: 11px;
        font-weight: 400;
        text-transform: none;
        color: #94a3b8;
      }

      .comment-name {
        color: #ffffff;
        display: flex;
        padding: 2px 8px;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
        font-family: "Inter", "Nunito", sans-serif;
        font-size: 10px;
        font-weight: 500;
      }
    }

    p {
      margin: 0 !important;
      color: #475569;
      font-size: 14px;
      line-height: 1.5;
      font-family: "Inter", "Nunito", sans-serif;
    }
  }
`;

export const AssignedUserWrapperUser = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 60px;
  width: 75%;
  cursor: pointer;
  padding: 4px;
  margin-top: 8px;
  border-radius: 8px;
`;

export const StyledBtn = styled.button`
  outline: none;
  border: none;
  background: var(--primary);
  color: #fff;
  border-radius: 4px;
  width: 40px;
  font-size: 24px;
  font-weight: 900;
  margin-left: 10px;
`;

export const StyledJobCardHeading = styled.h5`
  margin: 0 0 16px 0;
  color: #1e293b;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  font-family: "Inter", "Nunito", sans-serif;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 18px;
    background: linear-gradient(135deg, #6366f1 0%, #818cf8 100%);
    border-radius: 2px;
  }
`;

export const StyledStatusButton = styled.div<{
  background: string;
  color: string;
}>`
  button {
    background: ${(props) => props?.background ?? "white"};
    border: none;
    color: #fff;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    font-family: "Inter", "Nunito", sans-serif;
    min-width: 110px;
    padding: 8px 14px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
`;
